import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-errors" }
const _hoisted_2 = { class: "c-error" }
const _hoisted_3 = { style: {"flex-wrap":"wrap"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("既に会員情報が登録されています。 ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "こちら", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("からログインしてください。 ")
const _hoisted_7 = { class: "p-fields p-fields--confirm" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "お名前", -1)
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "c-field" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ふりがな", -1)
const _hoisted_13 = { class: "c-field__body" }
const _hoisted_14 = { class: "c-field" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ニックネーム", -1)
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = { class: "c-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "性別", -1)
const _hoisted_19 = { class: "c-field__body" }
const _hoisted_20 = { class: "c-field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "誕生日", -1)
const _hoisted_22 = { class: "c-field__body" }
const _hoisted_23 = { class: "c-field" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "郵便番号", -1)
const _hoisted_25 = { class: "c-field__body" }
const _hoisted_26 = { class: "c-field" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "都道府県", -1)
const _hoisted_28 = { class: "c-field__body" }
const _hoisted_29 = { class: "c-field" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "住所", -1)
const _hoisted_31 = { class: "c-field__body" }
const _hoisted_32 = { class: "c-field" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "電話番号", -1)
const _hoisted_34 = { class: "c-field__body" }
const _hoisted_35 = { class: "c-field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "結婚の有無", -1)
const _hoisted_37 = { class: "c-field__body" }
const _hoisted_38 = { class: "c-field" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "子供の有無", -1)
const _hoisted_40 = { class: "c-field__body" }
const _hoisted_41 = { class: "c-field" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "血液型", -1)
const _hoisted_43 = { class: "c-field__body" }
const _hoisted_44 = { class: "c-field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "職業・業種", -1)
const _hoisted_46 = { class: "c-field__body" }
const _hoisted_47 = { class: "c-field" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "収入", -1)
const _hoisted_49 = { class: "c-field__body" }
const _hoisted_50 = { class: "c-field" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "自動車運転免許の有無", -1)
const _hoisted_52 = { class: "c-field__body" }
const _hoisted_53 = {
  key: 0,
  class: "c-field"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "喫煙", -1)
const _hoisted_55 = { class: "c-field__body" }
const _hoisted_56 = { class: "c-field" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "飲酒", -1)
const _hoisted_58 = { class: "c-field__body" }
const _hoisted_59 = { class: "c-field" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "メルマガ受信", -1)
const _hoisted_61 = { class: "c-field__body" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { key: 2 }
const _hoisted_65 = {
  key: 1,
  class: "c-field"
}
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "趣味", -1)
const _hoisted_67 = { class: "c-field__body" }
const _hoisted_68 = {
  key: 2,
  class: "c-field"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "興味のあるスポーツ", -1)
const _hoisted_70 = { class: "c-field__body" }
const _hoisted_71 = {
  key: 3,
  class: "c-field"
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "休日の過ごし方", -1)
const _hoisted_73 = { class: "c-field__body" }
const _hoisted_74 = {
  key: 4,
  class: "c-field"
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "規約・プライバシーガイドライン", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__body" }, [
  /*#__PURE__*/_createElementVNode("p", null, "同意する")
], -1)
const _hoisted_77 = [
  _hoisted_75,
  _hoisted_76
]
const _hoisted_78 = { class: "c-field has-submit has-mt" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", null, "編集画面に戻る", -1)
const _hoisted_81 = [
  _hoisted_80
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("p", { class: "c-error" }, _toDisplayString(_ctx.errorMsgRef), 513), [
        [_vShow, _ctx.errorMsgRef]
      ]),
      _withDirectives(_createElementVNode("p", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, {
            to: { name: _ctx.routeNames.LOGIN },
            class: "c-link c-link--primary"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["to"]),
          _hoisted_6
        ])
      ], 512), [
        [_vShow, _ctx.isDispErrorMsgRef]
      ])
    ], 512), [
      [_vShow, _ctx.errorMsgRef || _ctx.isDispErrorMsgRef]
    ]),
    _createElementVNode("fieldset", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.lastName), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.firstName), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.lastKana), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.firstKana), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("p", null, _toDisplayString(_ctx.nickName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.gender === null || _ctx.userBase.commonAttrInfo.gender === "" || _ctx.userBase.commonAttrInfo.gender === undefined) ? "未選択" : (_ctx.userBase.commonAttrInfo.gender === "無回答") ? "回答しない" : _ctx.userBase.commonAttrInfo.gender), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.year) ? "" : _ctx.date.year + "年"), 1),
            _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.month) ? "" : _ctx.date.month + "月"), 1),
            _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.day) ? "" : _ctx.date.day + "日"), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.zipCode), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.prefecture), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("p", null, [
            _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.address), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.building), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.tel), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.isMarried === null || _ctx.userBase.commonAttrInfo.isMarried === undefined) ? "未選択" : (_ctx.userBase.commonAttrInfo.isMarried) ? "既婚" : "未婚"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.hasChild === null || _ctx.userBase.commonAttrInfo.hasChild === undefined) ? "未選択" : (_ctx.userBase.commonAttrInfo.hasChild) ? "有り" : "無し"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.bloodType === null || _ctx.userBase.commonAttrInfo.bloodType === "" || _ctx.userBase.commonAttrInfo.bloodType === undefined) ? "未選択" : (_ctx.userBase.commonAttrInfo.bloodType === "不明") ? "不明" : _ctx.userBase.commonAttrInfo.bloodType + "型"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("p", null, _toDisplayString(_ctx.JOB_LIST.find(choice => choice.value === _ctx.userMensMagazine.job && choice.value !== null)?.text || "未選択"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("p", null, _toDisplayString(_ctx.INCOME_LIST.find(choice => choice.value === _ctx.userMensMagazine.income && choice.value !== null)?.text || "未選択"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("p", null, _toDisplayString(_ctx.DRIVING_LICENCE_LIST.find(choice => choice.value === _ctx.userMensMagazine.drivingLicence && choice.value !== null)?.text || "未選択"), 1)
        ])
      ]),
      (!_ctx.firstLoginAfterMgn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _hoisted_54,
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("p", null, _toDisplayString(_ctx.IS_SMOKING_LIST.find(choice => choice.value === _ctx.userMensMagazine.isSmoking && choice.value !== null)?.text || "未選択"), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("p", null, _toDisplayString(_ctx.DRINKING_LIST.find(choice => choice.value === _ctx.userMensMagazine.drinking && choice.value !== null)?.text || "未選択"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", null, [
            (_ctx.userMensMagazine.mailMagazine?.weeklyPlayboy)
              ? (_openBlock(), _createElementBlock("p", _hoisted_62, "週刊プレイボーイ"))
              : _createCommentVNode("", true),
            (_ctx.userMensMagazine.mailMagazine?.webSportiva)
              ? (_openBlock(), _createElementBlock("p", _hoisted_63, "web Sportiva"))
              : _createCommentVNode("", true),
            (_ctx.userMensMagazine.mailMagazine?.mensNonNo)
              ? (_openBlock(), _createElementBlock("p", _hoisted_64, "MEN'S NON-NO"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (_ctx.userMensMagazine.mailMagazine?.weeklyPlayboy)
        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userMensMagazine.hobby, (item, idx) => {
                  return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(item === 'その他' ? `その他『${_ctx.userMensMagazine.hobbyOther}』` : item), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.userMensMagazine.mailMagazine?.webSportiva)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _hoisted_69,
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userMensMagazine.interestSports, (item, idx) => {
                  return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.userMensMagazine.mailMagazine?.webSportiva)
        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
            _hoisted_72,
            _createElementVNode("div", _hoisted_73, [
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userMensMagazine.spendHolidays, (item, idx) => {
                  return (_openBlock(), _createElementBlock("p", { key: idx }, _toDisplayString(item), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.firstServiceReg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_74, _hoisted_77))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_78, [
        _createElementVNode("button", {
          type: "button",
          class: "ha-btn is-submit",
          disabled: _ctx.isDeterringRef,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.upsert, this)))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.userBase.identityId ? "更新する" : "登録する"), 1)
        ], 8, _hoisted_79),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router.push({ name: _ctx.prevRoute }))),
          class: _normalizeClass(["ha-btn ha-btn--outline", { 'is-disabled':_ctx.isDeterringRef }])
        }, _hoisted_81, 2)
      ])
    ])
  ], 64))
}